import React, { useState, useCallback } from 'react';
import { map } from 'lodash/fp';
import PropTypes from 'prop-types';
import ItemSelector from './ItemSelector';
import ChevronDown from '../../themes/svg/chevronDown';
import ChevronUp from '../../themes/svg/chevronUp';

const ContainerExpander = ({
  sourceItemId,
  containerId,
  container,
  selectedCount,
  items,
}) => {
  const [isExpanded, setExpanded] = useState(true);

  const toggleExpand = useCallback((e) => {
    e.preventDefault();
    setExpanded(!isExpanded);
  }, [isExpanded, setExpanded]);

  return (
    <div className="containerExpander">
      <div className="containerHeading" role="button" tabIndex="-1" onClick={toggleExpand}>
        <span className="name">
          <span className="label">{container.charLabel}</span>
          {container.name}
        </span>
        {selectedCount > 0 && (
          <span className="selected">{selectedCount} Selected</span>
        )}
        <span className="icon">{isExpanded ? <ChevronDown /> : <ChevronUp />}</span>
      </div>
      {isExpanded && (
        <div className="itemList">
          {map(givenId => (
            <ItemSelector
              sourceItemId={sourceItemId}
              itemId={givenId}
              key={`${containerId}-selector-${givenId}`}
            />
          ), items)}
        </div>
      )}
    </div>
  );
};

ContainerExpander.propTypes = {
  sourceItemId: PropTypes.string.isRequired,
  containerId: PropTypes.string.isRequired,
  container: PropTypes.shape({
    charLabel: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedCount: PropTypes.number.isRequired,
};

export default ContainerExpander;
